import appStore from 'store';
import api from './api';
import { STATUS_TYPE, PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: 'unaudited',
    detailDialogVisible: false,
    auditDetail: {},
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    },
    setAuditDetail(state, payload) {
      state.auditDetail = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      commit('setPagination', { page: query.page, size: query.size });

      api.getAuditList(query).then(({ data }) => {
        commit('setAuditList', data);
      });
    },
    approve({ commit }, data) { // eslint-disable-line
      return new Promise(resolve => {
        api.approveAudit(data).then(res => {
          resolve(res);
        });
      });
    },
    detail({ commit }, val) {
      commit('setAuditDetail', {});
      commit('setAuditDetail', val);
    }
  }
};

appStore.registerModule('tribeAudit', store);
